<template>
<CRow>
    <CCol col="12" sm="8" class="mx-auto">
        <CCard>
            <CCardBody>
                <Form :promotion="promotion" :submit="submit" ref="editForm" />
            </CCardBody>
        </CCard>
    </CCol>
</CRow>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Form } from './partials'

export default {
    name: 'Edit',

    components: {
        Form,
    },

    data() {
        return {
            id: this.$route.params.id,

            PERCENT: 0,
            AMOUNT: 1,
        }
    },

    computed: {
        ...mapGetters('promotion', [
            'promotionById'
        ]),
        promotion() {
            return this.promotionById(this.id)
        },
    },

    watch: {
        'promotion.limit_amount': function(limit_amount) {
            if(limit_amount > 0) {
                this.promotion.unlimited = false
            }
        }
    },

    methods: {
        ...mapActions('promotion', {
            editPromotion: 'edit'
        }),
        ...mapActions('messageComponent', [
            'setMsg',
            'resetMsg'
        ]),
        ...mapActions('loadingComponent', [
            'setShowLoading'
        ]),
        submit() {
            const editForm = this.$refs.editForm
            this.setShowLoading()
            this.resetMsg()

            this.editPromotion(this.promotion).then(result => {
                this.setShowLoading(false)
                this.$router.push({name: 'promotions'})
            }).catch(result => {
                if(result.data) {
                    editForm.$refs.form.setErrors(result.data);
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.'+result.tag),
                    type: 'danger'
                })
            })
        },
    }
}
</script>